<template>
  <div>
    <loader v-if="isLoading" />
    <main-header :login="true" />
    <div class="main-block stats">
      <div>
        <div class="top__block">
          <h1>{{ $t('stats') }}</h1>
        </div>
        <div class="scroll_container">
          <div
            id="sort-bar"
            style="margin-top: 0"
          >
            <multiselect
              v-model="filterItems"
              class="modal__select--single multiselect"
              label="name"
              track-by="name"
              :placeholder="$t('applications')"
              :options="appsFilterList"
              :multiple="true"
              :searchable="true"
              :allow-empty="true"
              @input="filterApps(filterItems)"
            />
          </div>
          <div class="table__info">
            <simple-multiselect
              :label="$t('show_entries')"
              :class-name="'count__list'"
              :placeholder="'25'"
              :multiple="false"
              :model="valueEntries"
              :options="listOptions"
              @searchItem="limitPage"
            />
            <calendar-block
              :min-date="false"
              :max-date="true"
              :date-from="dateFrom"
              :date-to="dateTo"
              :full-calendar="true"
              @searchDateRange="searchDateRange"
            />
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('application') }}</th>
                <th>{{ $t('sent_table') }}</th>
                <th>{{ $t('deliv') }}</th>
                <th>{{ $t('error') }}</th>
                <th>{{ $t('not_sent') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in statsList"
                :key="item.id_app"
              >
                <td>{{ item.id_app }}</td>
                <td>{{ item.app_name }}</td>
                <td>{{ item.successful_sum }}</td>
                <td>{{ item.converted_sum }}</td>
                <td>{{ item.failed_sum }}</td>
                <td>{{ item.errored_sum }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-show="showPagination">
          <ul class="pagination">
            <li v-if="showPreviousButton">
              <a @click="paginationPage(1)">{{ $t('first') }}</a>
            </li>
            <li v-if="showPreviousButton">
              <a @click="paginationPage(currentPage - 1)">
                {{ $t('prev') }}
              </a>
            </li>
            <li
              v-for="page in visiblePages"
              :key="page"
              :class="{ active: currentPage === page }"
            >
              <a @click="paginationPage(page)">{{ page }}</a>
            </li>
            <li v-if="showNextButton">
              <a @click="paginationPage(currentPage + 1)">
                {{ $t('next') }}
              </a>
            </li>
          </ul>
          <div>
            <p
              v-for="item in paginatedData"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import MainHeader from "@/components/header/header.vue";
import { HTTP } from "@/../axios-config";
import AddTags from "@/components/tags/addTag.vue";
import Multiselect from "vue-multiselect";
import EditTags from "@/components/tags/editTag.vue";
import filtersMultiselect from "@/components/elements/filtersMultiselect.vue";
import SeeParams from "@/components/tags/seeParams.vue";
import ErrorModal from "@/components/elements/errorModal.vue";
import calendarBlock from "@/components/elements/calendarBlock.vue";
import SimpleMultiselect from "@/components/elements/simpleMultiselect.vue";
import Loader from "@/components/elements/loader.vue";

export default {
  name: "TagsPage",
  components: {
    Loader,
    SimpleMultiselect, calendarBlock,
    ErrorModal,
    SeeParams,
    filtersMultiselect,
    EditTags,
    Multiselect,
    AddTags,
    MainHeader,
  },
  data() {
    return {
      isLoading: false,
      statsList: [],
      paginationData: [],
      showPagination: false,
      showEntries: 10,
      currentPage: 1,
      maxVisiblePages: 5,
      appsFilterList: [],
      filterAppsId: "all",
      filterItems: [],
      countPages: null,
      listOptions: ["10", "25", "50", "100"],
      valueEntries: "10",
      dateFrom: new Date(new Date() - 172800000),
      dateTo: new Date(),
      dateFromFormater: "",
      dateToFormater: "",
    };
  },
  mounted() {
    this.searchDateRange(this.dateFrom, this.dateTo);
    // this.fetchStats();
  },
  methods: {
    dateFormatter(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    searchDateRange(dateFrom, dateTo) {
      this.dateFromFormater = this.dateFormatter(dateFrom);
      this.dateToFormater = this.dateFormatter(dateTo);
      this.showCalendar = false;
      this.fetchStats();
    },
    filterApps(params) {
      this.filterAppsId = (params.length > 0) ? params.map(app => app.id).join(',') : "all";
      this.fetchStats();
    },
    paginationPage(page) {
      this.currentPage = page;
      this.fetchStats();
    },
    limitPage(limit) {
      this.valueEntries = limit;
      this.fetchStats();
    },
    fetchStats() {
      this.isLoading = true;
      HTTP.get(`analytics/apps?apps=${this.filterAppsId}&dateFrom=${this.dateFromFormater}&dateTo=${this.dateToFormater}&page=1&limit=${this.valueEntries}`)
        .then(response => {
          let data = response.data;
          this.statsList = data.content;
          this.countPages = data.pagination.pages
          this.showPagination = (this.countPages > 1) ? true : false;
          this.appsFilterList = data.filter.apps;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false
          console.log('error', error);
        })
    },
  },
  computed: {
    visiblePages() {
      const startPage = Math.max(
        1,
        this.currentPage - Math.floor(this.maxVisiblePages / 2)
      );
      const endPage = Math.min(
        startPage + this.maxVisiblePages - 1,
        this.countPages
      );

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    showPreviousButton() {
      return this.showPagination;
    },
    showNextButton() {
      return this.currentPage < this.countPages;
    },
    paginatedData() {
      let startIndex =
        (this.currentPage - 1) * this.showEntries;
      const endIndex = startIndex + this.showEntries;
      return this.paginationData.slice(startIndex, endIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-block {
  width: 100vw !important;
  height: 100vh;
  display: block;
  align-items: flex-start;
  justify-content: center;
  padding: 120px 80px;
  box-sizing: border-box;
}

.count__list {
  label {
    width: max-content;
    margin-left: 0;
    margin-right: 5px;
  }
}
</style>

<style lang="scss">
.stats {
  .pagination {
    padding-bottom: 30px;
  }
  .multiselect__select {
    min-width: 10px !important;
    width: 10px!important;
  }

  #sort-bar .multiselect__select {
    right: 28px;
    top: 28px;
  }
}
</style>